<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5">
        <Select v-model="project_id" filterable style="width:300px" placeholder="选择项目" @on-change="getProjectData()">
          <Option
            v-for="pr in projects"
            :key="pr.id"
            :value="pr.id"
            :label="pr.name"
          >
            {{ pr.name }}
            <Tag>{{ pr.finished ? '已完成' : '进行中' }}</Tag>
            <Tag>{{ pr.group }}</Tag>
          </Option>
        </Select>
        <Select v-model="view" style="width:140px" placeholder="选择视图" @on-change="getProjectData()">
          <Option
            v-for="p in views"
            :value="p.key"
            :key="p.key"
          >
            {{ p.name }}
          </Option>
        </Select>
      </div>
      <div class="zzl-view-top-actions flex-wrap">
        <Button class="zzl-view-top-refresh" type="default" :disabled="!project_id" :loading="dataLoading" @click="getProjectData">刷新列表</Button>
        <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;">
      <!-- 左侧：筛选并获取 / 下载原始数据 -->
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="dataLoading" fix size="large">
          <div class="zzl-view-data-loading-text">加载任务数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">数据下载和清理</div>
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;justify-content:flex-end;">
              <Button
                type="primary"
                icon="md-download"
                :disabled="!project_id"
                :loading="dataLoading"
                @click="getProjectData"
              >
                获取项目数据
              </Button>
              <i-switch v-model="extractForm" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">提取表格</span>
              <i-switch v-model="onlyQuestion" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">隐藏合规项</span>
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
              <Button @click="copyRawData" type="info" :disabled="!aiText">复制原始数据</Button>
              <Button @click="downloadRawData" :disabled="!aiText">下载 .txt</Button>
            </div>
          </div>
          <div class="zzl-view-left-track flex-wrap split5" style="margin-bottom:8px;align-items:center;flex-wrap:wrap;gap:8px;flex-shrink:0;">
            <span style="font-size:12px;color:#64748b;">跟踪记录</span>
            <BaseDate v-model="tracking_startDate" placeholder="开始日期" />
            <BaseDate v-model="tracking_endDate" placeholder="结束日期" />
            <Button size="small" @click="cleanData">按跟踪条件刷新</Button>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="4"
              class="zzl-view-fill-textarea"
              style="width:100%;flex:1;min-height:0;"
              placeholder="先选择项目与视图，点击「获取项目数据」，清洗后的任务文本将显示在此。"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="zzl-view"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('zzl-view') }} · zzl-view）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <!-- 右侧：仅报告 -->
      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button
              type="primary"
              icon="md-play"
              :loading="ai_executings"
              :disabled="aiText.length < 10"
              @click="CreateByAI"
            >
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {deepCleanTask, renderEFormMap, extractAttachments} from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';

moment.locale('zh-cn');

export default {
  components: {AiPromptPanel, AiMarkdownStreamPanel},
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateKey: 'ai_work',
      pageStateFields: ['project_id', 'task_id', 'onlyQuestion', 'extractForm', 'tracking_startDate', 'tracking_endDate', 'userText'],
      aiText: '',
      userText: '',
      onlyQuestion: false,
      extractForm: false,
      tracking_startDate: null,
      tracking_endDate: null,
      ai_executings: false,
      dataLoading: false,
      result: '',
      rawTasks: [],
      task_id: '',
      project_id: 'pid65054f01eabec',
      view: 'recent',
      projects: [],
      views: [
        {key: 'all', name: '全部工作'},
        {key: 'finished', name: '已完工作'},
        {key: 'allToDo', name: '未完工作'},
        {key: 'recent', name: '近期工作'},
        {key: 'myTodo', name: '我的待办'},
        {key: 'today', name: '今日动态'},
        {key: 'yestoday', name: '昨日动态'},
        {key: 'theDayBeforeYestoday', name: '前日动态'},
        {key: 'aboutMe', name: '我的工作'},
        {key: 'alert', name: '预警工作'},
        {key: 'nonActivation', name: '尚未启动'},
      ],
    };
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.getProjects();
    });
  },
  methods: {
    labelForMod,
    getProjects() {
      this.$api.get('logined_zzl/projects').then((res) => {
        this.projects = res.data.data;
      });
    },
    zzlReportPdfStem() {
      const project = this.projects.find((p) => p.id === this.project_id);
      const name = project ? project.name.replace(/[/\\?%*:|"<>]/g, '_') : 'export';
      return `${name}_${this.view}_${moment().format('YYYYMMDD')}`;
    },
    getProjectData() {
      if (!this.project_id) {
        return;
      }
      this.dataLoading = true;
      this.$api.get(`logined_zzl/task_details?view=${this.view}&pid=${this.project_id}`).then((res) => {
        this.rawTasks = res.data.data || [];
        this.cleanData();
      }).catch((e) => {
        console.error(e);
        this.Error(e && e.message ? e.message : '获取任务数据失败');
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    cleanData() {
      this.__savePageState();
      const tasks = this.rawTasks || [];
      const eformmap = {};
      let text = `\n# 以下为所有任务数据\n` + tasks.map((t) => deepCleanTask(
          t,
          this.tracking_startDate,
          this.tracking_endDate,
          null,
        this.extractForm ? eformmap : null,
        this.onlyQuestion,
      )).join('\n');
      if (this.extractForm) {
        text += renderEFormMap(eformmap);
      }
      const {text: cleaned} = extractAttachments(text);
      this.aiText = cleaned;
    },
    copyRawData() {
      if (!this.aiText) {
        return;
      }
      this._zzlCopyText(this.aiText, '已复制原始数据');
    },
    downloadRawData() {
      if (!this.aiText) {
        return;
      }
      const blob = new Blob([this.aiText], {type: 'text/plain;charset=utf-8'});
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      const project = this.projects.find((p) => p.id === this.project_id);
      const slug = (project && project.name) ? project.name.replace(/[/\\?%*:|"<>]/g, '_') : this.project_id;
      a.download = `${slug}_${this.view}_${moment().format('YYYYMMDD_HHmm')}.txt`;
      a.click();
      URL.revokeObjectURL(a.href);
      this.Success('已开始下载');
    },
  },
};
</script>

